import { render, staticRenderFns } from "./NpRecognitionCategoryCreate.vue?vue&type=template&id=4bf3cab5&scoped=true"
import script from "./NpRecognitionCategoryCreate.vue?vue&type=script&lang=js"
export * from "./NpRecognitionCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionCategoryCreate.vue?vue&type=style&index=0&id=4bf3cab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3cab5",
  null
  
)

export default component.exports